import React from 'react';
import { Box, Card, Flex, Text, Heading, Select } from '@radix-ui/themes';

export function Field({ label, hint, children }) {
  return <Flex direction="column" gap="2"><Text as="label" size="2" weight="medium"><Flex direction="column" gap="2">{label}{children}</Flex></Text>{hint && <Text size="1" color="gray">{hint}</Text>}</Flex>;
}

export function ChoiceSelect({ label, value, onChange, options, disabled }) {
  return <Select.Root value={value} onValueChange={onChange} disabled={disabled}><Select.Trigger aria-label={label} /><Select.Content>{options.map(option => <Select.Item key={option.value} value={option.value}>{option.label}</Select.Item>)}</Select.Content></Select.Root>;
}

export function EmptyState({ icon: Icon, title, children }) {
  return <Card variant="surface" size="4"><Flex direction="column" gap="3" align="center" py="7"><Box style={{ color: 'var(--accent-11)' }}>{Icon && <Icon size={30} />}</Box><Heading size="5">{title}</Heading><Text as="div" size="2" color="gray" align="center">{children}</Text></Flex></Card>;
}

export function CoverPhoto({ src, alt, fallback }) {
  return <Box height="160px"><Flex height="100%" width="100%" align="center" justify="center" style={{ background: 'var(--gray-a3)', overflow: 'hidden', borderRadius: 'var(--radius-3)' }}>{src ? <img src={src} alt={alt} loading="lazy" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : fallback}</Flex></Box>;
}
